import Seo from "@/components/feature/Seo";
import FaqList from "@/components/feature/FaqList";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import ProgressList from "./components/ProgressList";
import HotBoard from "./components/HotBoard";
import LatestProgress from "./components/LatestProgress";
import DisputePanel from "./components/DisputePanel";
import FactCheckPanel from "./components/FactCheckPanel";
import VoicesPanel from "./components/VoicesPanel";
import CtaBand from "./components/CtaBand";
import { generalFaqs, siteInfo } from "@/mocks/site";
import { topics } from "@/mocks/topics";

const structuredData = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteInfo.name,
    url: "https://dfjor.cn/",
    description: siteInfo.intro,
    email: siteInfo.email,
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteInfo.name,
    url: "https://dfjor.cn/",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://dfjor.cn/category/reyi?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "实时热议榜",
    itemListElement: [...topics]
      .sort((a, b) => b.heat - a.heat)
      .slice(0, 6)
      .map((topic, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: topic.title,
        url: `https://dfjor.cn/topic/${topic.id}`,
      })),
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: generalFaqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="蝌蚪爆料 - 热议发酵追踪 · 争议回应与辟谣核查"
        description="蝌蚪爆料追踪网络热议事件的发酵全过程，梳理争议焦点、当事方回应与辟谣核查，帮你看清重点、不被带节奏，持续更新事件最新进展。"
        keywords="蝌蚪爆料,热议追踪,争议焦点,当事方回应,辟谣核查,舆论观察"
        path="/"
        jsonLd={structuredData}
      />

      <Hero />
      <CategoryGrid />

      <div className="px-4 py-12 md:px-6 md:py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_340px]">
          <ProgressList />
          <HotBoard />
        </div>
      </div>

      <div className="px-4 pb-12 md:px-6 md:pb-16 lg:px-8">
        <LatestProgress />
      </div>

      <div className="px-4 pb-12 md:px-6 md:pb-16 lg:px-8">
        <DisputePanel />
      </div>

      <div className="px-4 pb-12 md:px-6 md:pb-16 lg:px-8">
        <FactCheckPanel />
      </div>

      <div className="px-4 pb-12 md:px-6 md:pb-16 lg:px-8">
        <VoicesPanel />
      </div>

      <section className="bg-background-100 px-4 py-12 md:px-6 md:py-16 lg:px-8">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">常见问题</h2>
            <p className="mt-2 text-sm text-foreground-600">关于内容来源、核查标准与更新方式的说明。</p>
          </div>
        </div>
        <div className="mt-8">
          <FaqList items={generalFaqs} />
        </div>
      </section>

      <div className="px-4 pt-12 md:px-6 md:pt-16 lg:px-8">
        <CtaBand />
      </div>

      <div className="h-8" />
    </>
  );
}